import { extendTheme } from "@chakra-ui/react"
import { deepCopy } from '@/utils/deepCopy'

type Dict = Record<string, any>

function merge(first: Dict, second?: Dict): Dict{
  for (let key in second) {
    first[key] = first[key] && first[key].toString() === "[object Object]" ?
    merge(first[key], second[key]) : first[key] = second[key];
  }

  return first;
}


function getConfig(config: Dict) {
  const { colors: lightColors, shadows: lightShadows } = config.light
  const { colors: darkColors, shadows: darkShadows } = config.dark

  const colors = {
    light: { ...lightColors },
    dark: { ...darkColors },
  }

  const shadows = {
    light: { ...lightShadows },
    dark: { ...darkShadows },
  }

  const getTheme = (colorMode: string) => {
    const theme = config[colorMode]

    theme.colors = {
      ...theme.colors,
      ...colors,
    },
    theme.shadows = {
      ...theme.shadows,
      ...shadows,
    }
    theme.config = {
      ...theme.config,
      useSystemColorMode: false,
      initialColorMode: colorMode,
    }

    return extendTheme(theme)
  }

  config.light = getTheme('light')
  config.dark = getTheme('dark')

  return config
}


export function normalizeConfig(defaultConfig: Dict, userConfig: Dict) {
  const copyConfig = deepCopy(defaultConfig, ['light.components', 'dark.components'])
  const mergeConfig = merge(copyConfig, userConfig)
  const config = getConfig(mergeConfig)

  return config
}